import PropTypes from "prop-types";
import { useState } from "react";
import { resolveImage } from "../cart-redesign/pricing";

/* First letters of the product name, used when no catalogue image resolves. */
const initials = (name) =>
  String(name || "?")
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");

/*
 * Some catalogue entries carry an image path the backend no longer serves,
 * so a broken load falls back to the initials tile rather than an empty box.
 */
const Thumb = ({ image, name }) => {
  const [broken, setBroken] = useState(false);
  const src = image ? resolveImage(image) : "";

  return (
    <span className="c4rtn__thumb">
      {src && !broken ? (
        <img src={src} alt="" loading="lazy" onError={() => setBroken(true)} />
      ) : (
        <span className="c4rtn__thumb-fallback" aria-hidden="true">
          {initials(name)}
        </span>
      )}
    </span>
  );
};

Thumb.propTypes = {
  image: PropTypes.string,
  name: PropTypes.string,
};

export default Thumb;
